module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.dataLoaded) ? _c('div', {
    staticClass: "index",
    class: {
      'iphone-x': _vm.iphoneX, 'show-banner': _vm.showDownBanner
    }
  }, [_c('download-banner', {
    attrs: {
      "pageType": 'index',
      "link": 'index',
      "position": 'top'
    },
    on: {
      "close-banner": _vm.closeBanner,
      "banner-close": _vm.closeBanner
    }
  }), _vm._v(" "), _c('search', {
    staticClass: "i-search"
  }), _vm._v(" "), _c('cart'), _vm._v(" "), _c('vue-loadmore', {
    attrs: {
      "on-refresh": _vm.onRefresh,
      "refresh-text": '加载中',
      "show-success-text": false,
      "finished": _vm.finished
    }
  }, [(_vm.data.modules) ? _c('div', _vm._l((_vm.data.modules), function(mod, index) {
    return _c('div', {
      key: index,
      style: (_vm.renderModStyl(mod))
    }, [(mod.type === 'image-banner' && mod.showFlag) ? _c('image-banner', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags,
        "paginateType": "number"
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'image-index' && mod.showFlag) ? _c('image-index', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new' && mod.showFlag) ? _c('article-new', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "hideTitle": true,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'video' && mod.showFlag) ? _c('article-video', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "multiVideo": _vm.multiVideo
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'image' && mod.showFlag) ? _c('article-image', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-image' && mod.showFlag) ? _c('new-image', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-banner' && mod.showFlag) ? _c('new-banner', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-line' && mod.showFlag) ? _c('new-line', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-list' && mod.showFlag) ? _c('new-list', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'new-time' && mod.showFlag) ? _c('new-time', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType
      }
    }) : _vm._e(), _vm._v(" "), (mod.type === 'buoy' && mod.showFlag) ? _c('article-buoy', {
      attrs: {
        "data": mod.data,
        "modIndex": index,
        "pageType": _vm.pageType,
        "memberTags": _vm.data.memberTags
      }
    }) : _vm._e()], 1)
  }), 0) : _vm._e()]), _vm._v(" "), _c('navbar-bottom', {
    attrs: {
      "activeIndex": "0"
    }
  }), _vm._v(" "), (_vm.upgradePopData) ? _c('upgrade-pop', {
    attrs: {
      "data": _vm.upgradePopData,
      "dialog": _vm.dialog
    },
    on: {
      "upgrade-close": _vm.closeUpgradePopAction
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPopFlag) ? _c('pop-com', {
    attrs: {
      "id": _vm.popId,
      "name": _vm.popName,
      "image": _vm.popImage,
      "link": _vm.popLink,
      "dialog": _vm.dialog
    },
    on: {
      "pop-close": _vm.closePopAction
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30c512ff"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-index-V4/index.vue
// module id = 988
// module chunks = 13